export default __webpack_public_path__ + "static/media/about-3.572b59e0.png";